import { AdminApiClient } from '@guiker/booking-shared'
import { AuthLevel, generateBaseApiContext } from '@guiker/react-framework'

export const { useContext: useAdminBookingContext, NestedRouter: AdminBookingNestedRouter } = generateBaseApiContext({
  authLevel: AuthLevel.ADMIN,
  apiClientGen: AdminApiClient,
  cacheKey: ({ bookingId }: { bookingId: string }) => `readOneBooking-${bookingId}`,
  fetcher: (client, { bookingId }: { bookingId: string }) => client.readOneBooking({ pathParams: { bookingId } }),
})
